import { makeStyles, alpha } from "@material-ui/core/styles";
import { AEROS, stateText } from "./aerosTokens";

// Estilos compartilhados dos modais Aeros Dark (cabeçalho 20/24/16 com título
// 16/700 + subtítulo 12, corpo com gap 16, rodapé com divisor e botões
// Cancelar/gradiente). Extraído dos mockups de Contatos, Agenda e Respostas
// Rápidas; cada modal usa makeStyles próprio só para o que é específico.
const useAerosModalStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const border = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";
  const borderInput = isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.1)";
  const cyanText = stateText(theme, AEROS.cyan, "info");
  return {
    form: { display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "inherit" },
    header: {
      padding: "20px 24px 16px",
      display: "flex",
      alignItems: "center",
      gap: 12,
      borderBottom: `1px solid ${border}`,
      flexShrink: 0,
    },
    title: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: "-0.01em",
      color: theme.palette.text.primary,
    },
    subtitle: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 2 },
    closeButton: {
      marginLeft: "auto",
      padding: 4,
      color: theme.palette.aeros.textTertiary,
      "& .MuiSvgIcon-root": { fontSize: 20 },
    },
    body: {
      padding: "20px 24px",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      overflowY: "auto",
      ...theme.scrollbarStyles,
      "& > *": { flexShrink: 0 },
    },
    grid2: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 10,
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
    },
    fieldLabel: {
      fontSize: 12,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginBottom: 5,
      display: "block",
    },
    fieldLabelFocus: { color: cyanText },
    input: {
      width: "100%",
      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
        backgroundColor: theme.palette.aeros.surface,
        fontSize: 13.5,
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: borderInput },
      "& .MuiOutlinedInput-input": { padding: "9px 12px" },
      "& .MuiOutlinedInput-adornedStart": { paddingLeft: 12 },
      "& .MuiOutlinedInput-adornedStart .MuiOutlinedInput-input": { paddingLeft: 0 },
      "& .MuiOutlinedInput-adornedEnd": { paddingRight: 10 },
      "& .MuiOutlinedInput-multiline": { padding: "12px 14px" },
      "& .MuiOutlinedInput-multiline .MuiOutlinedInput-input": { padding: 0 },
      "& .MuiSelect-root": { padding: "9px 32px 9px 12px", display: "flex", alignItems: "center", gap: 8 },
      "& .MuiSelect-icon": { color: theme.palette.text.secondary, right: 8 },
      "& .MuiAutocomplete-inputRoot": { padding: "1px 12px" },
      "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": { padding: "8px 0" },
      "& .MuiAutocomplete-endAdornment": { right: 6 },
      "& .MuiInputAdornment-root .MuiSvgIcon-root": { fontSize: 16 },
    },
    inputSmall: {
      "& .MuiOutlinedInput-root": { borderRadius: 8, fontSize: 12.5 },
      "& .MuiOutlinedInput-input": { padding: "7px 10px" },
      "& .MuiSelect-root": { padding: "7px 30px 7px 10px" },
    },
    hint: {
      fontSize: 11,
      color: theme.palette.aeros.textTertiary,
      marginTop: 5,
      display: "flex",
      alignItems: "center",
      gap: 4,
      "& .MuiSvgIcon-root": { fontSize: 13 },
    },
    // caixa cinza com título/descrição + controle à direita (toggles)
    optionBox: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 14px",
      backgroundColor: theme.palette.aeros.surface,
      border: `1px solid ${border}`,
      borderRadius: 12,
      minWidth: 0,
      "& > .MuiSvgIcon-root": { fontSize: 17, color: stateText(theme, "#C08BFF", "purple") },
    },
    optionTitle: { fontSize: 12.5, fontWeight: 600, color: theme.palette.text.primary },
    optionDesc: { fontSize: 11, color: theme.palette.text.secondary },
    // seção com cabeçalho (Informações adicionais)
    section: {
      border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.08)"}`,
      borderRadius: 12,
      overflow: "hidden",
    },
    sectionHead: {
      display: "flex",
      alignItems: "center",
      padding: "10px 14px",
      backgroundColor: isLight ? "rgba(15,20,40,0.02)" : "rgba(255,255,255,0.02)",
      fontSize: 12.5,
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    linkButton: {
      marginLeft: "auto",
      fontSize: 12,
      fontWeight: 600,
      color: cyanText,
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: 0,
      font: "inherit",
      fontSize: 12,
      fontWeight: 600,
      "& .MuiSvgIcon-root": { fontSize: 15 },
      "&:hover": { textDecoration: "underline" },
      "&:disabled": { opacity: 0.5, cursor: "default" },
    },
    dangerLink: {
      fontSize: 12,
      fontWeight: 600,
      color: stateText(theme, AEROS.error, "error"),
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: 0,
      font: "inherit",
      fontSize: 12,
      fontWeight: 600,
      "& .MuiSvgIcon-root": { fontSize: 15 },
      "&:hover": { textDecoration: "underline" },
    },
    footer: {
      padding: "16px 24px",
      borderTop: `1px solid ${border}`,
      display: "flex",
      alignItems: "center",
      gap: 10,
      flexShrink: 0,
      flexWrap: "wrap",
    },
    footerActions: { marginLeft: "auto", display: "flex", gap: 10 },
    cancelButton: {
      border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.16)"}`,
      color: theme.palette.text.primary,
      borderRadius: 10,
      padding: "7px 16px",
      fontWeight: 600,
      fontSize: 13,
    },
    submitButton: {
      borderRadius: 10,
      padding: "7px 18px",
      fontWeight: 700,
      fontSize: 13,
      position: "relative",
      "& .MuiButton-startIcon": { marginRight: 4 },
      "& .MuiSvgIcon-root": { fontSize: 16 },
    },
    buttonProgress: {
      color: AEROS.success,
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    // chips/pills
    chip: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      fontSize: 11,
      fontWeight: 600,
      borderRadius: 6,
      padding: "3px 8px",
      whiteSpace: "nowrap",
      "& .MuiSvgIcon-root": { fontSize: 12, cursor: "pointer" },
    },
    pill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      fontSize: 10.5,
      fontWeight: 600,
      borderRadius: 99,
      padding: "2px 9px",
      whiteSpace: "nowrap",
      "& .MuiSvgIcon-root": { fontSize: 12 },
    },
    pillWarning: {
      color: stateText(theme, AEROS.warning, "warning"),
      backgroundColor: alpha(AEROS.warning, 0.1),
    },
    pillSuccess: {
      color: stateText(theme, AEROS.success, "success"),
      backgroundColor: alpha(AEROS.success, 0.1),
    },
    avatar: {
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      color: "#07080D",
      flex: "none",
      overflow: "hidden",
      "& img": { width: "100%", height: "100%", objectFit: "cover" },
    },
  };
});

export default useAerosModalStyles;
